import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Historia.css";
import historiaImg from "../assets/images/fachada.jpg";
import logo from "../assets/images/logo.png";

const Historia = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="historia-page">
      {/*  Banner superior */}
      <div className="historia-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Historia Institucional</h1>
          <p className="lead">38 años formando profesionales técnicos de excelencia</p>
        </div>
      </div>

      {/*  Historia principal */}
      <div className="container py-5">
        <div className="row align-items-center mb-5" data-aos="fade-right">
          <div className="col-md-6 mb-4 mb-md-0">
            <img src={historiaImg} alt="Instituto Gilda Ballivián" className="historia-img" />
          </div>
          <div className="col-md-6">
            <h2 className="section-title">Nuestra Historia</h2>
            <p className="text-justify">
              El <strong>Instituto de Educación Superior Tecnológico Público “Gilda Liliana Ballivián Rosado”</strong>,
              es una institución educativa líder en el marco de la excelencia con experiencia en la formación
              de profesionales técnicos especializados. Brinda a los jóvenes de nuestro país una sólida formación
              humanística, científica y tecnológica acorde con las exigencias del mercado laboral.
            </p>
            <p className="text-justify">
              Desde hace más de 38 años, promovemos e impulsamos la investigación, la ciencia y la tecnología
              con el fin de atender las demandas del mercado competitivo y fomentar la autogestión
              de la pequeña y mediana empresa.
            </p>
          </div>
        </div>

        {/* Línea de tiempo */}
        <div className="timeline-section" data-aos="fade-up">
          <h2 className="section-title text-center mb-5">Reseña Histórica</h2>
          <div className="timeline">
            <div className="timeline-item left">
              <div className="content">
                <h5>1980</h5>
                <p>
                  Se crea la <strong>Escuela Superior de Educación Profesional (ESEP)</strong> de San Juan de Miraflores
                  mediante la <strong>Resolución Ministerial N°0309-80-ED</strong>, con las carreras de Administración,
                  Construcción Civil, Contabilidad, Electricidad y Electrónica.
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="content">
                <h5>1980</h5>
                <p>
                  El <strong>24 de junio</strong>, mediante R.M. N°0755-80-ED, se otorga el nombre
                  de “<strong>Gilda Liliana Ballivián Rosado</strong>” en homenaje a la destacada científica peruana.
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="content">
                <h5>1983</h5>
                <p>
                  Por <strong>R.S. N°131-83-ED</strong>, se autoriza la adecuación como Instituto Superior Tecnológico
                  Público, ofertando las carreras de Construcción Civil, Contabilidad, Electricidad, Electrónica y Mecánica de Producción.
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="content">
                <h5>1984 - 1996</h5>
                <p>
                  Se incorporan nuevas carreras: <strong>Administración</strong> (1984),
                  <strong>Mecánica Automotriz</strong> y <strong>Computación e Informática</strong> (1996).
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="content">
                <h5>2005 - 2006</h5>
                <p>
                  El instituto es <strong>revalidado</strong> oficialmente mediante Resoluciones Directorales N°412-2005-ED
                  y N°429-2006-ED, continuando su funcionamiento bajo la Ley N°29394.
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="content">
                <h5>Actualidad</h5>
                <p>
                  Hoy, el <strong>IESTP Gilda Ballivián</strong> continúa formando profesionales de calidad,
                  fortaleciendo su compromiso con la innovación, la investigación y la acreditación institucional.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/*  Logo final */}
        <div className="text-center mt-5" data-aos="zoom-in">
          <img src={logo} alt="Logo Gilda Ballivián" className="historia-logo" />
          <p className="fw-semibold mt-3 text-secondary">
            Instituto de Excelencia Tecnológica del Cono Sur — San Juan de Miraflores, Lima - Perú
          </p>
        </div>
      </div>
    </section>
  );
};

export default Historia;
